export enum Tags {
  ALL_MEALS = 14,
  //Meal type category
  A_LA_CARTE = 1001,
  //Frozen category
  FROZEN = 1021,
  //Sourcing standards category
  NAE_PROTEIN_SOURCING_STANDARD = 1023,
  CONVENTIONAL_PROTEIN_SOURCING_STANDARD = 1024,
  //Shelf life category
  PREVIOUSLY_FROZEN = 1026,
  FRESH = 1027,
  EXTENDED_FRESH = 1028,
  PANTRY = 1029,

  NEW = 1010,
}

export enum TagCategories {
  DIETARY_TEMPLATE = 1,
  MEAL_TYPE = 3,
  SERVINGS = 5,
  KOSHER = 7,
  SOURCING_STANDARDS = 9,
  SHELF_LIFE = 10,
}

/**
 * Used for the /meals details page shelf life card
 */
export const shelfLifeTagIdToDisplayInfoMap: Record<number, { copy: string }> =
  {
    [Tags.PREVIOUSLY_FROZEN]: {
      copy: 'This product was previously frozen and may arrive partially thawed.  It should be consumed within 6 days of delivery or frozen upon receipt.  Please check labels for the best by dates on each product.',
    },
    [Tags.FRESH]: {
      copy: 'This product is made fresh each week and should be consumed within 3-4 days of delivery.  Please check labels for the best by dates on each product.',
    },
    [Tags.EXTENDED_FRESH]: {
      copy: 'This product is made fresh each week and packed with the latest film seal technology so they stay fresh for about a week after delivery.  Please check labels for the best by dates on each product.',
    },
    [Tags.PANTRY]: {
      copy: 'This product is able to be stored for several weeks after delivery.  Please check labels for the best by dates on each product.',
    },
  };

/**
 * Used for the meal card details modal.
 */

export const mealDetailsModalShelfLifeDisplayInfoMap: Record<
  number,
  { title: string; subtitle: string; copy: string }
> = {
  [Tags.PREVIOUSLY_FROZEN]: {
    title: 'Previously Frozen',
    subtitle: 'within 6 days, or refreeze',
    copy: "Frozen when packed and may thaw in transit — that's expected. Keep refrigerated.",
  },
  [Tags.FRESH]: {
    title: 'Fresh',
    subtitle: 'best within 3–4 days',
    copy: 'Made fresh this week. Check the best-by date on the label.',
  },
  [Tags.EXTENDED_FRESH]: {
    title: 'Extended Fresh',
    subtitle: 'best within 5–7 days',
    copy: 'Made fresh this week and film-sealed to last longer. Check the best-by date on the label.',
  },
  [Tags.PANTRY]: {
    title: 'Pantry',
    subtitle: 'keeps for several weeks',
    copy: 'Shelf-stable — store in your pantry.',
  },
};
